import { render, staticRenderFns } from "./-index.vue?vue&type=template&id=30f3a6c1&scoped=true&"
import script from "./-index.vue?vue&type=script&lang=js&"
export * from "./-index.vue?vue&type=script&lang=js&"
import style0 from "./-index.vue?vue&type=style&index=0&id=30f3a6c1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f3a6c1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/SvgIcon.vue').default})
